/**
 * R. Venue Public Data Service
 * Interacts with the secure public NCB proxy
 */

const PUBLIC_BASE = '/api/public';

const fetchPublic = async (operation, table, data = null, params = null) => {
  let queryString = '';
  if (params) {
    const searchParams = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null) searchParams.append(k, v);
    });
    queryString = `?${searchParams.toString()}`;
  }

  const url = `${PUBLIC_BASE}/${operation}/${table}${queryString}`;
  const options = {
    method: operation === 'create' ? 'POST' : 'GET',
    headers: { 'Content-Type': 'application/json' }
  };

  if (data && operation === 'create') {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(url, options);
    const result = await response.json().catch(() => ({ status: 'error', message: 'Non-JSON response' }));
    
    if (!response.ok) {
      return { status: 'error', message: result.message || `Request failed: ${response.status}` };
    }
    return result;
  } catch (err) {
    return { status: 'error', message: 'Network error' };
  }
};

export const publicDataService = {
  getGalleryImages: () => fetchPublic('read', 'gallery_images'),
  getGalleryVideos: () => fetchPublic('read', 'gallery_videos'),
  getTestimonials: () => fetchPublic('read', 'testimonials'),
  getSiteSettings: () => fetchPublic('read', 'site_settings_7523'),
  getPageSections: () => fetchPublic('read', 'page_sections_7523'),
  getPageSectionItems: () => fetchPublic('read', 'page_section_items_7523'),
  getBusinessProfile: () => fetchPublic('read', 'business_profile_7523'),
  getRateSettings: () => fetchPublic('read', 'rates_config_7523'),
  
  createBooking: (data) => fetchPublic('create', 'bookings', data),
  createContactMessage: (data) => fetchPublic('create', 'contact_messages', data),

  /**
   * Fetches booking availability for calendar display.
   * Note: The public proxy is restricted to return only non-private fields.
   */
  getPublicAvailability: () => fetchPublic('read', 'bookings', null, { limit: 100 })
};